import { useState, useEffect } from 'react';

export function useIgnoredOffers(storeName) {
    const [ignoredOffers, setIgnoredOffers] = useState(() => {
        const stored = localStorage.getItem(`ignoredOffers_${storeName}`);
        return stored ? JSON.parse(stored) : {};
    });

    useEffect(() => {
        localStorage.setItem(`ignoredOffers_${storeName}`, JSON.stringify(ignoredOffers));
    }, [ignoredOffers, storeName]);

    const ignoreOffer = (pageUrl, offerText, offerType) => {
        setIgnoredOffers(prev => ({
            ...prev,
            [pageUrl]: {
                ...prev[pageUrl],
                [offerType]: [...(prev[pageUrl]?.[offerType] || []), offerText]
            }
        }));
    };

    const restoreOffer = (pageUrl, offerText, offerType) => {
        setIgnoredOffers(prev => ({
            ...prev,
            [pageUrl]: {
                ...prev[pageUrl],
                [offerType]: (prev[pageUrl]?.[offerType] || []).filter(o => o !== offerText)
            }
        }));
    };

    const isOfferIgnored = (pageUrl, offerText, offerType) => {
        return ignoredOffers[pageUrl]?.[offerType]?.includes(offerText) || false;
    };

    const hasIgnoredOffers = Object.keys(ignoredOffers).some(pageUrl => {
        const pageIgnored = ignoredOffers[pageUrl];
        return (pageIgnored?.mismatches?.length > 0 || pageIgnored?.missing?.length > 0);
    });

    return { ignoredOffers, ignoreOffer, restoreOffer, isOfferIgnored, hasIgnoredOffers };
}
